import React, { useContext, useState, useEffect } from 'react';
import { Table } from 'rsuite';
import './live-campaigns.scss';
import 'rsuite/dist/rsuite.min.css';
import { default as t } from '../../../utils/i18n';
import { Button, ModalWindow, AppTooltip, ActionLink } from '../../atoms';
import { DashService, AnalysisService } from '../../../services';
import { UserContext, ToasterContext } from '../../../context';
import { useHistory } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDebounceEffect } from '../../../hooks';
import ReactTooltip from 'react-tooltip';
import { ReactComponent as LoaderImg } from '../../../assets/svg/spinner.svg';

function LiveCampaigns(props) {
  const { user } = useContext(UserContext);
  const history = useHistory();
  const { message, setMessage } = useContext(ToasterContext);
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const username = user?.username;
  const [sortColumn, setSortColumn] = React.useState('');
  const [sortType, setSortType] = React.useState('asc');
  const [isNickName, setIsNickName] = React.useState(true);
  const [toaster, setToaster] = useState(false);
  const [showDeleteCampaignModal, setShowDeleteCampaignModal] = useState(false);
  const [hasMore, setHaseMore] = React.useState(true);
  const [limit, setLimit] = React.useState(20);
  const [page, setPage] = React.useState(1);
  const [liveCampaignData, setLiveCampaignData] = React.useState([]);
  const [tableList, SetTableList] = React.useState([]);
  const [deleteData, setDeleteData] = useState({});
  const liveCampaignType = 'live';
  const completedCampaignType = 'completed';
  const [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const [disableLoader, toggleLoader] = useState(true);
  const loaderTimeout = 120000;

  useEffect(() => {
    if (message?.message) {
      setToaster(true);
      clearToaster();
    }
  }, []);

  React.useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }
    window.addEventListener('resize', handleResize);
    return _ => {
      window.removeEventListener('resize', handleResize);
    };
  });

  useEffect(() => {
    setTimeout(() => {
      toggleLoader(false);
    }, loaderTimeout);
  });

  const clearToaster = () => {
    setTimeout(() => {
      console.log('clear called');
      setToaster(false);
      setMessage([]);
    }, 7000);
  };

  useEffect(() => {
    if (props?.selectedAdAccount?.value) {
      setPage(1);
      getCampaigns(1);
    }
  }, [props?.selectedAdAccount]);

  const updateDateFormat = val => {
    const d = new Date(val);
    d.setUTCHours(0, 0, 0, 0);
    const yyyy = d.getFullYear();
    let mm = d.getMonth() + 1; // Months start at 0!
    let dd = d.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    return dd + '-' + mm + '-' + yyyy;
  };

  const getDateRange = (startTime, stopTime) => {
    if (stopTime) {
      return updateDateFormat(startTime) + ' to ' + updateDateFormat(stopTime);
    } else {
      return updateDateFormat(startTime) + ' ' + 'onwards';
    }
  };

  const getData = () => {
    const tableData = [];

    tableList?.map((list, index) => {
      const childCount = list?.analysis?.length;
      let data = {
        id: list.id,
        key: list.id + index + Math.random().toString(),
        campaign_name: list.name,
        objective: list.objective,
        dateRange: getDateRange(list.start_time, list.stop_time),
        is_readyForAnalysis: list.is_readyForAnalysis,
        budget:
          list?.budget === 'Not Set'
            ? list?.budget
            : nFormatter(list?.budget, 1) + '(' + capitalizeFirstLetter(list?.budget_mode) + ')',
      };
      if (childCount > 1) {
        data.children = generateChildren(list);
        data.kpi = childCount > 1 ? childCount : null;
        data.status = checkNotify(list);
      } else if (childCount === 1) {
        data.kpi = list?.analysis[0]?.kpiLabel;
        data.status = list?.analysis[0]?.status;
        data.performance = list?.analysis[0]?.performance;
        data.analysisIds = list?.analysis[0]?.anaysisid;
        data.childCount = childCount;
        data.sys_id = list?.analysis[0]?.kpi;
        data.error_reason = list?.analysis[0]?.error_reason;
      } else {
        data.kpi = '-';
        data.status = 'ANALYZE';
        data.performance = '-';
      }
      data.progressLoaderFlag = Date.now() - list?.importedAt < loaderTimeout;
      // console.log(data.key);
      tableData.push(data);
    });
    return tableData;
  };

  const checkNotify = list => {
    if (list.analysis.some(e => e.toBeNotified === true)) {
      return 'NOTIFY';
    } else {
      return '';
    }
  };

  const generateChildren = list => {
    let children = [];
    list.analysis.map((el, index) => {
      children.push({
        id: list.id,
        key: Math.random().toString(),
        campaign_name: list.name,
        objective: list.objective,
        dateRange: getDateRange(list.start_time, list.stop_time),
        is_readyForAnalysis: list.is_readyForAnalysis,
        budget:
          list?.budget === 'Not Set'
            ? list?.budget
            : nFormatter(list?.budget, 1) + '(' + capitalizeFirstLetter(list?.budget_mode) + ')',
        kpi: el.kpiLabel,
        sys_id: el.kpi,
        status: el.status,
        performance: el.performance,
        isChild: true,
        analysisIds: el.anaysisid,
        error_reason: el?.error_reason,
      });
    });
    return children;
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const nFormatter = (num, digits) => {
    const lookup = [
      { value: 1, symbol: '' },
      { value: 1e3, symbol: 'K' },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const item = lookup
      .slice()
      .reverse()
      .find(item => {
        return num >= item.value;
      });
    return item ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol : '0';
  };

  const handleSortColumn = (sortColumn, sortType) => {
    setPage(1);
    setSortColumn(sortColumn);
    setSortType(sortType);
    getCampaigns(1, sortColumn, sortType);
  };

  const handleRowClick = rowData => {
    // todo
    console.log(rowData, 'rowData');
    if (props?.campaignType === liveCampaignType) {
      if (!rowData.children) {
        if (rowData.status === 'READY') {
          history.push(`/recommendation?id=${rowData.id}&sys_id=${rowData.sys_id}`);
        } else if (rowData.is_readyForAnalysis) {
          history.push(`/kpi-optimization?id=${rowData.id}&sys_id=${rowData.sys_id}`);
        } else {
          // setMessage({
          //   message:
          //     'Insights cannot be requested against this campaign as it is newly imported. Kindly try after some time',
          //   isError: true,
          // });
          // setToaster(true);
          // clearToaster();
          ReactTooltip.show(rowData.key);
        }
      }
    } else {
      if (rowData.status === 'READY') {
        history.push(`/recommendation?id=${rowData.id}&sys_id=${rowData.sys_id}`);
      }
    }
  };

  const toggleName = e => {
    e.stopPropagation();
    setIsNickName(!isNickName);
  };

  const onAddClick = (event, data) => {
    event.stopPropagation();
    if (data.is_readyForAnalysis) {
      const url = data?.sys_id
        ? `/kpi-optimization?id=${data.id}&sys_id=${data.sys_id}`
        : `/kpi-optimization?id=${data.id}`;
      history.push(url);
    } else {
      // setMessage({
      //   message:
      //     'Insights cannot be requested against this campaign as it is newly imported. Kindly try after some time',
      //   isError: true,
      // });
      // setToaster(true);
      // clearToaster();
    }
  };

  const deleteReport = (event, data) => {
    event.stopPropagation();
    const deleteObj = data;
    deleteObj['subHeading'] =
      data?.children?.length > 1 || data?.childCount == 1
        ? t('reportTable.campaign.delete.insight.subHeading')
        : data?.isChild
          ? t('reportTable.delete.insight.subHeading')
          : t('reportTable.campaign.delete.subHeading');
    deleteObj['buttonText'] =
      data?.children?.length > 1 || data?.childCount == 1
        ? t('delete.campaign.insights')
        : t('reportTable.campaign.delete');
    setDeleteData(deleteObj);
    setShowDeleteCampaignModal(true);
  };

  const handleOnCloseDeleteModal = () => {
    setShowDeleteCampaignModal(false);
  };

  const handleOnCancel = e => {
    e.preventDefault();
    setShowDeleteCampaignModal(false);
  };

  const handleOnConfirm = async () => {
    let anaIds = [];
    if (deleteData?.isChild) {
      anaIds.push(deleteData?.analysisIds);
    } else if (deleteData?.children?.length > 1) {
      deleteData?.children?.map(child => {
        anaIds.push(child?.analysisIds);
      });
    } else {
      anaIds = [];
    }
    const payload = {
      deleteCampaign: deleteData?.isChild ? false : true,
      analysisIds: anaIds,
    };
    deleteCampaign(payload);
  };

  const handleOnCampaignInsightsDelete = e => {
    e.preventDefault();
    let anaIds = [];
    if (deleteData?.children?.length > 1) {
      deleteData?.children?.map(child => {
        anaIds.push(child?.analysisIds);
      });
    } else {
      anaIds.push(deleteData?.analysisIds);
    }
    const payload = {
      deleteCampaign: false,
      analysisIds: anaIds,
    };
    deleteCampaign(payload);
  };

  async function deleteCampaign(payload) {
    try {
      const deleteRes = await AnalysisService.deleteCampaign(
        userAccessToken,
        username,
        deleteData?.id,
        payload
      );
      const delResponse = deleteRes.data?.data;
      setShowDeleteCampaignModal(false);
      getCampaigns(1);
      getData();
    } catch (error) {
      setShowDeleteCampaignModal(false);
    }
  }

  useDebounceEffect(
    () => {
      if (props?.selectedAdAccount) {
        setPage(1);
        getCampaigns(1);
      }
    },
    500,
    [props?.dropdownFilterby, props?.searchKeyword]
  );

  async function getCampaigns(pageNo = false, sortCol = false, sortingType = false) {
    let pagination = pageNo ? pageNo : page;
    const sortColumnName = sortCol ? sortCol : sortColumn;
    const sortingTypeName = sortingType ? sortingType : sortType;
    try {
      const requestData = {
        accessToken: userAccessToken,
        username: username,
        adAccountId: props?.selectedAdAccount?.value,
        type: props?.campaignType,
        limit: limit,
        page: pagination,
        sortType: sortingTypeName,
        sortColumn: sortColumnName,
        searchKeyword: props?.searchKeyword.trim(),
        filterBy: props?.filterBy,
      };
      const campaignData = await DashService.listImportedCampaign(requestData);
      const campaigns = campaignData?.data?.data;
      setLiveCampaignData(campaigns);
      if (pagination === 1) {
        SetTableList([...campaigns?.campaignsList]);
      } else {
        SetTableList(prev => [...prev, ...campaigns?.campaignsList]);
      }
      props.updateCount(campaigns?.pagination?.totalRecords, props?.campaignType);
      if (props?.campaignType === liveCampaignType && pagination === 1) {
        requestData.type = completedCampaignType;
        const completed = await DashService.listImportedCampaign(requestData);
        props.updateCount(completed?.data?.data?.pagination?.totalRecords, completedCampaignType);
      }
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        //console.log(dataCode);
      }
    }
  }

  const onExpandChange = async (expanded, rowData) => {
    console.log(expanded, rowData);
    if (expanded && rowData.status === 'NOTIFY') {
      try {
        const response = await AnalysisService.notifyAnalysis(
          userAccessToken,
          username,
          rowData?.id
        );
        console.log('response from NOTIFy', response);
        // TODO: test after API changes.
        let items = [...tableList];
        var foundIndex = items.findIndex(x => x.id == rowData.id);

        let item = { ...items[foundIndex] };
        item.analysis.map(x => {
          x.toBeNotified = false;
        });

        items[foundIndex] = item;
        // 5. Set the state to our new copy
        SetTableList(items);
      } catch (error) { }
    }
  };

  const TableCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Table.Cell
        {...props}
        title={rowData[dataKey]}
        className={`${rowData?.isChild ? 'child-background' : ''} 
        ${(rowData.status === 'READY' || rowData.is_readyForAnalysis) && rowData?.children
            ? 'pointer-auto'
            : rowData.status === 'READY' || rowData.is_readyForAnalysis
              ? ''
              : 'disable-class'
          }`}
      >
        {rowData[dataKey]}
      </Table.Cell>
    );
  };

  const NameCell = ({ rowData, dataKey, isNickName, onChange, ...props }) => {
    return (
      <div>
        <AppTooltip id="tool-tip" place="left" className="c-table-info-icon--tooltip" />
        <Table.Cell
          {...props}
          className={`${rowData?.isChild ? 'child-background child-padding' : 'campaign-name'} ${(rowData.status === 'READY' || rowData.is_readyForAnalysis) && rowData?.children
            ? 'pointer-auto'
            : rowData.status === 'READY' || rowData.is_readyForAnalysis
              ? ''
              : 'disable-class'
            }`}
          title={rowData[dataKey]}
          rowData={rowData}
        >
          {<span>{isNickName ? rowData[dataKey] : rowData['id']}</span>}
        </Table.Cell>
      </div>
    );
  };

  const getWidth = (value = 10) => {
    return window.innerWidth / value;
  };
  const StatusCell = ({ rowData, dataKey, onChange, ...props }) => {
    return (
      <Table.Cell {...props} className={`${rowData?.isChild ? 'child-background' : ''}`}>
        <div>
          <AppTooltip id="tool-tip1" place="left" className="c-table-info-icon--tooltip" />
          <div
            className={`options ${rowData[dataKey] === 'PROCESSING'
              ? 'in-progress'
              : rowData[dataKey] === 'READY'
                ? 'ready'
                : rowData[dataKey] === 'NEW'
                  ? 'new'
                  : rowData[dataKey] === 'ACCEPTED'
                    ? 'veiw'
                    : rowData[dataKey] === 'ANALYZE' && props?.campaigntype === 'live'
                      ? 'analyze'
                      : rowData[dataKey] === 'NOTIFY'
                        ? 'notify'
                        : rowData[dataKey] === 'ERROR'
                          ? 'error' : ''
              }`}
          >
            {rowData[dataKey] === 'PROCESSING' ? (
              <>
                <span>
                  <i className="eva eva-clock-outline"></i>
                  {t('create.report.show.answer.option.options3.type')}
                </span>
              </>
            ) : (
              ''
            )}
            {rowData[dataKey] === 'READY' ? (
              <>
                <span>
                  <i className="eva eva-bell-outline"></i>
                  {t('create.report.show.answer.option.options4.type')}
                </span>
              </>
            ) : (
              ''
            )}
            {rowData[dataKey] === 'NEW' ? (
              <>
                {disableLoader && rowData?.progressLoaderFlag && !rowData.is_readyForAnalysis ? (
                  <>
                    <LoaderImg className="revolving-spinner" />
                    {t('create.report.show.answer.option.options3.type')}
                  </>
                ) : (
                  <span className="new">{t('create.report.show.answer.option.options1.type')}</span>
                )}
              </>
            ) : (
              ''
            )}
            {rowData[dataKey] === 'ANALYZE' ? (
              <>
                {disableLoader && props?.campaigntype === 'live' && rowData?.progressLoaderFlag && !rowData.is_readyForAnalysis ? (
                  <>
                    <LoaderImg className="revolving-spinner" />
                    {t('create.report.show.answer.option.options3.type')}
                  </>
                ) : (

                  props?.campaigntype === 'live' ? (
                    rowData?.kpi === '-' && !rowData.is_readyForAnalysis ? (
                      <span>
                        <i className="eva eva-clock-outline"></i>
                        {t('create.report.show.answer.option.options3.type')}
                      </span>
                    ) :
                      (
                        <span className="analyze">
                          <i className="eva eva-search"></i>
                          {t('perf.analyse')}
                        </span>
                      )
                  ) : (
                    <span className='analyze-completed'>
                      <i
                        className="eva eva-trash-2-outline"
                        data-tip={t('report.tooltip.delete')}
                        data-for="tool-tip1"
                        onClick={event => deleteReport(event, rowData)}
                      ></i>
                    </span>
                  )
                )}
              </>
            ) : (
              ''
            )}
            {rowData[dataKey] === 'NOTIFY' ? (
              <>
                <span className="notify">
                  <i className="eva eva-bell"></i>
                </span>
              </>
            ) : (
              ''
            )}
            {rowData[dataKey] === 'ACCEPTED' ? (
              <>
                <span>
                  <i className="eva eva-checkmark-circle-2-outline"></i>
                  {t('create.report.show.answer.option.options2.type')}
                </span>
              </>
            ) : (
              ''
            )}

            {rowData[dataKey] === 'ERROR' ? (
              <>
                <span>
                  {' '}
                  <i className="eva eva-alert-triangle-outline"></i>
                  {t('create.report.show.answer.option.options5.type')}
                </span>
              </>
            ) : (
              ''
            )}
          </div>
          <div className={rowData[dataKey] === 'ERROR' ? 'action-icons error' : 'action-icons'}>
            {rowData[dataKey] === 'ERROR' ? (
              <i
                className="eva eva-alert-triangle-outline red-color"
                data-tip={rowData?.error_reason}
                data-for="tool-tip1"
              ></i>
            ) : (
              <></>
            )}
            {props?.campaigntype === 'live' ? (
              <i
                className="eva eva-maximize-outline"
                data-tip={
                  !rowData?.is_readyForAnalysis
                    ? t(
                      'Insights cannot be requested against this campaign as it is newly imported. Kindly try after some time'
                    )
                    : t('Generate new KPI Insights')
                }
                data-for="tool-tip1"
                // ref={ref =>{(Math.random()).toString() = ref}}
                onClick={event => onAddClick(event, rowData)}
              ></i>
            ) : (
              ''
            )}
            <i
              className="eva eva-trash-2-outline"
              data-tip={t('report.tooltip.delete')}
              data-for="tool-tip1"
              onClick={event => deleteReport(event, rowData)}
            ></i>
          </div>
        </div>
      </Table.Cell>
    );
  };
  const loadMore = () => {
    if (
      props?.selectedAdAccount?.value &&
      tableList?.length < liveCampaignData?.pagination?.totalRecords
    ) {
      setPage(page + 1);
      getCampaigns(page + 1);
    }
  };
  return (
    <div>
      <div className="sticky-toaster">
        {toaster ? (
          <div className="report-toaster report-toaster-pos">
            {!message.isError && (
              <span>
                <i className="eva eva-checkmark-outline"></i>
              </span>
            )}
            {message.isError && (
              <div className="icon-error">
                <i className="eva eva-close-outline"></i>
              </div>
            )}
            {message?.message}
          </div>
        ) : (
          ''
        )}
      </div>

      <AppTooltip id="tool-tip" place="left" className="c-table-info-icon--tooltip" />
      <InfiniteScroll
        dataLength={tableList?.length} //This is important field to render the next data
        next={loadMore}
        hasMore={hasMore}
      >
        <div className="report-performance">
          <Table
            isTree={true}
            rowKey="key"
            data={getData()}
            sortColumn={sortColumn}
            sortType={sortType}
            headerHeight={50}
            autoHeight={true}
            onSortColumn={handleSortColumn}
            onRowClick={e => handleRowClick(e)}
            virtualized
            affixHeader={225}
            className={'pointer-cursor'}
            onExpandChange={(event, rowData) => onExpandChange(event, rowData)}
          >
            <Table.Column width={getWidth(4)} align="left" sortable>
              <Table.HeaderCell>
                <i
                  className="eva eva-repeat-outline"
                  data-tip={
                    isNickName ? t('campaign.tooltip.toggle2') : t('campaign.tooltip.toggle1')
                  }
                  data-for="tool-tip"
                  onClick={event => toggleName(event)}
                ></i>
                {isNickName ? t('define.stepper.table.campaignName') : t('perf.campaign.id')}
                <span className="name-padding">
                  <i
                    className="eva eva-info-outline"
                    data-tip={t('optimisation.table.campaignName')}
                    data-for="tool-tip3"
                  ></i>
                  <AppTooltip
                    className="c-table-info-icon--tooltip"
                    id="tool-tip3"
                    place="bottom"
                  />
                </span>
              </Table.HeaderCell>
              <NameCell dataKey="campaign_name" isNickName={isNickName} />
            </Table.Column>

            <Table.Column width={getWidth(6)} resizable>
              <Table.HeaderCell>
                {t('report.table.report.date')}
                <span className="date-padding">
                  <i
                    className="eva eva-info-outline"
                    data-tip={t('optimisation.table.date')}
                    data-for="tool-tip2"
                  />
                  <AppTooltip
                    className="c-table-info-icon--tooltip"
                    id="tool-tip2"
                    place="bottom"
                  />
                </span>
              </Table.HeaderCell>
              <TableCell dataKey="dateRange" />
            </Table.Column>

            <Table.Column width={getWidth(7)} resizable>
              <Table.HeaderCell>
                {t('perf.budget')} ({liveCampaignData?.accountInfo?.currency})
                <React.Fragment>
                  <span className="date-padding">
                    <i
                      className="eva eva-info-outline"
                      data-tip={t('optimisation.table.budget')}
                      data-for="tool-tip2"
                    ></i>
                    <AppTooltip
                      className="c-table-info-icon--tooltip"
                      id="tool-tip2"
                      place="bottom"
                    />
                    {/* <EmailTooltip  id={t('report-campaign-name')} emailToolTip={t('optimisation.table.budget')} /> */}
                  </span>
                </React.Fragment>
              </Table.HeaderCell>
              <TableCell dataKey="budget" />
            </Table.Column>

            <Table.Column width={getWidth(7)} resizable sortable>
              <Table.HeaderCell>
                {t('perf.objective')}
                <span className="objective-padding">
                  <i
                    className="eva eva-info-outline"
                    data-tip={t('optimisation.table.objective')}
                    data-for="tool-tip2"
                  ></i>
                  <AppTooltip
                    className="c-table-info-icon--tooltip"
                    id="tool-tip2"
                    place="bottom"
                  />
                </span>
              </Table.HeaderCell>
              <TableCell dataKey="objective"></TableCell>
            </Table.Column>

            <Table.Column width={getWidth(7)} resizable sortable>
              <Table.HeaderCell>
                {t('perf.kpi')}
                <span className="kpi-padding">
                  <i
                    className="eva eva-info-outline"
                    data-tip={t('optimisation.table.selectedKpi')}
                    data-for="tool-tip2"
                  ></i>
                  <AppTooltip
                    className="c-table-info-icon--tooltip"
                    id="tool-tip2"
                    place="bottom"
                  />
                </span>
              </Table.HeaderCell>
              <TableCell dataKey="kpi" />
            </Table.Column>

            {/* <Table.Column width={getWidth()} resizable>
            <Table.HeaderCell>{t('Performance')}</Table.HeaderCell>
            <TableCell dataKey="performance" />
          </Table.Column> */}

            <Table.Column width={getWidth(10)}>
              <Table.HeaderCell>
                {t('reportTable.text.status')}
                <span className="status-padding">
                  <i
                    className="eva eva-info-outline"
                    data-tip={t('optimisation.table.status')}
                    data-for="tool-tip"
                  ></i>
                  <AppTooltip
                    className="c-table-info-icon--tooltip mytooltip"
                    id="tool-tip"
                    place="left"
                    multiline={true}
                  />
                </span>
              </Table.HeaderCell>
              <StatusCell dataKey="status" campaigntype={props?.campaignType} />
            </Table.Column>
          </Table>
        </div>
      </InfiniteScroll>

      <div className="report-delete">
        <ModalWindow
          className="fqa-modal--showanswer"
          isOpen={showDeleteCampaignModal}
          onRequestClose={handleOnCloseDeleteModal}
          heading={t('reportTable.campaign.delete.heading')}
        >
          <p className="fqa-model-showanswer--message message-font">{deleteData?.subHeading}</p>
          {(deleteData?.childCount == 1 || deleteData?.children?.length > 1) && (
            <p>
              <ActionLink
                anchor={true}
                value={t('delete.campaign.insights.link')}
                handleClick={handleOnCampaignInsightsDelete}
              />
            </p>
          )}
          <div className="fqa-model-pa--actions">
            <ActionLink
              anchor={true}
              value={t('reportTable.campaign.delete.cancel')}
              handleClick={handleOnCancel}
            />
            <Button
              className="fqa-model-pa--actions-confirm delete-button"
              label={deleteData?.buttonText}
              handleClick={handleOnConfirm}
            />
          </div>
        </ModalWindow>
      </div>
    </div>
  );
}

export default LiveCampaigns;
